import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import { GamingHubSummary } from './GamingHubSummary';
import { MembershipStatus } from './MembershipStatus';
import { Overlay } from './Overlay';
import { PaymentHubSummary } from './PaymentHubSummary';
import { getMyHubsSummary } from './Portfolio.actions';
import { StakingHubSummary } from './StakingHubSummary';
import { WalletSummary } from './WalletSummary';
import { TradingHubSummary } from './TradingHubSummary';
import { Flexed, TabSelectButton, Tabs } from '../../styles/GlobalComponents';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router';
import {
  MY_HUBS,
  MY_HUBS_BIG_WHALE,
  MY_HUBS_FLIPME_CARDS,
  MY_HUBS_GAMING,
  MY_HUBS_PAYMENT,
  MY_HUBS_STAKING,
  MY_HUBS_TRADING,
  MY_HUBS_TRAVEL
} from '../../routes/routes';
import { Conversion } from './Conversion/Conversion';
import { BigWhaleSummary } from './BigWhaleSummary';
import { WithdrawStepsEnum } from './WithdrawHubs/types';
import { TravelSummary } from './TravelSummary';

export const Portfolio = () => {
  const dispatch = useAppDispatch();

  const [withdrawStep, setWithdrawStep] = useState<WithdrawStepsEnum>(
    WithdrawStepsEnum.INIT
  );

  const { loading, loadingHubs, walletSummary } = useAppSelector(
    (state) => state.portfolio
  );

  const { canBuyTravelPackages } = useAppSelector(
    (state) => state.auth.userInfo
  );

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (walletSummary !== null) return;
    dispatch(getMyHubsSummary());
  }, [dispatch]);

  const pathname = location.pathname;

  if (loading) return <Spinner fullScreen={true} />;

  const showTabs = () => {
    if (canBuyTravelPackages) {
      return MY_HUBS_TRAVEL;
    } else {
      return MY_HUBS_BIG_WHALE;
    }
  };

  return (
    <AnimatedDashboard zoom>
      <WalletSummary />
      <MembershipStatus />

      <Flexed mb='20'>
        <Tabs>
          {canBuyTravelPackages && (
            <TabSelectButton
              onClick={() => history.push(MY_HUBS_TRAVEL)}
              selected={pathname === MY_HUBS_TRAVEL}>
              <div>Travel</div>
            </TabSelectButton>
          )}

          {/* <TabSelectButton
              onClick={() => history.push(MY_HUBS_BIG_WHALE)}
              selected={pathname === MY_HUBS_BIG_WHALE}>
              <div>BigWhale</div>
            </TabSelectButton>
          

          <TabSelectButton
            onClick={() => history.push(MY_HUBS_TRADING)}
            selected={pathname === MY_HUBS_TRADING}>
            <div>Trading</div>
          </TabSelectButton>
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_PAYMENT)}
            selected={pathname === MY_HUBS_PAYMENT}>
            <div>Payment</div>
          </TabSelectButton>

          <TabSelectButton
            onClick={() => history.push(MY_HUBS_GAMING)}
            selected={pathname === MY_HUBS_GAMING}>
            <div>Gaming</div>
          </TabSelectButton>
          <TabSelectButton
            onClick={() => history.push(MY_HUBS_STAKING)}
            selected={pathname === MY_HUBS_STAKING}>
            <div>Staking</div>
          </TabSelectButton> */}
        </Tabs>
      </Flexed>

      {loadingHubs && <Spinner fullScreen={true} transparent />}

      <Switch location={location} key={location.pathname}>
        <Redirect exact from={MY_HUBS} to={showTabs()} />
        <Route path={MY_HUBS_TRAVEL}>
          <TravelSummary />
        </Route>
        <Route path={MY_HUBS_BIG_WHALE}>
          <BigWhaleSummary />
        </Route>
        <Route path={MY_HUBS_TRADING}>
          <TradingHubSummary />
        </Route>
        <Route path={MY_HUBS_PAYMENT}>
          <PaymentHubSummary
            setWithdrawStep={setWithdrawStep}
            withdrawStep={withdrawStep}
          />
        </Route>

        <Route path={MY_HUBS_FLIPME_CARDS}>
          <PaymentHubSummary
            setWithdrawStep={setWithdrawStep}
            withdrawStep={withdrawStep}
          />
        </Route>
        <Route path={MY_HUBS_GAMING}>
          <GamingHubSummary
            setWithdrawStep={setWithdrawStep}
            withdrawStep={withdrawStep}
          />
        </Route>
        <Route path={MY_HUBS_STAKING}>
          <StakingHubSummary
            setWithdrawStep={setWithdrawStep}
            withdrawStep={withdrawStep}
          />
        </Route>
      </Switch>

      <Conversion pathname={pathname} />

      <Overlay />
    </AnimatedDashboard>
  );
};
